import React from "react";
import { motion } from "framer-motion";

const StatCard = ({ label, value, unit, icon, action, onNavigate, delay, cta, subtext }) => {
    return (
        <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay, duration: 0.4, ease: "easeOut" }}
            onClick={() => onNavigate(action)}
            className="bg-white p-6 rounded-3xl border border-gray-100 shadow-sm hover:shadow-xl hover:shadow-[#5b6f00]/5 hover:-translate-y-1 transition-all duration-300 cursor-pointer group relative overflow-hidden flex flex-col justify-between h-full"
        >
            <div className="absolute top-0 right-0 w-32 h-32 bg-gradient-to-bl from-gray-50 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500 rounded-bl-full pointer-events-none"></div>

            <div>
                <div className="flex justify-between items-start mb-4 relative z-10">
                    <div className="w-12 h-12 rounded-2xl bg-[#fdfcf7] border border-gray-100 text-[#5b6f00] flex items-center justify-center transition-transform duration-500 group-hover:scale-110 group-hover:bg-[#5b6f00] group-hover:text-white shadow-sm">
                        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" d={icon} />
                        </svg>
                    </div>
                    <div className="bg-gray-50 text-gray-500 text-[10px] font-bold uppercase tracking-widest px-2 py-1 rounded-lg group-hover:bg-[#5b6f00]/10 group-hover:text-[#5b6f00] transition-colors">
                        View
                    </div>
                </div>

                <div className="relative z-10">
                    <p className="text-xs font-bold text-gray-500 mb-1">{label}</p>
                    <div className="flex items-baseline gap-1.5">
                        <span className="text-3xl font-black text-gray-900 tracking-tight">{value}</span>
                        {unit && <span className="text-sm font-bold text-gray-400">{unit}</span>}
                    </div>
                    {subtext && (
                        <p className="text-[11px] font-medium text-gray-400 mt-1 leading-snug">
                            {subtext}
                        </p>
                    )}
                </div>
            </div>

            {cta && (
                <div className="relative z-10 mt-4 pt-4 border-t border-gray-50">
                    <p className="text-xs text-[#5b6f00] font-bold opacity-80 group-hover:opacity-100 transition flex items-center gap-1">
                        {cta} 
                        <svg className="w-3 h-3 transition-transform group-hover:translate-x-1" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M14 5l7 7m0 0l-7 7m7-7H3" /></svg>
                    </p>
                </div>
            )}
        </motion.div>
    );
};

export default StatCard;
